<script>
import axios from 'axios'
import uploadcare from 'uploadcare-widget/uploadcare.min.js'
import Vue from 'vue'
import BaseLoader from '../loader'

export default Vue.extend({
  name: 'Unsplash',
  components: {
    BaseLoader,
  },
  props: {
    dialogApi: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
    clientId: {
      type: String,
      default: '65ae3b8016fd8202f01d88fe1aaa34ec10b6a7cfab55bc998e5c0d9c3a9e3d43',
    },
    endpoint: {
      type: String,
      default: 'https://api.unsplash.com/photos/random/?count=15&orientation=landscape',
    },
  },
  data() {
    return {
      loading: false,
      loadingMore: false,
      images: [],
    }
  },
  async created() {
    this.loading = true
    await this.fetchImages()
    this.loading = false
  },
  methods: {
    async fetchImages() {
      this.loadingMore = true

      const data = await axios.get(this.endpoint, {
        headers: {
          Authorization: `Client-ID ${this.clientId}`,
        },
      })

      const { data: results } = data
      this.images = [
        ...this.images,
        ...results,
      ]

      this.loadingMore = false
    },
    chooseImage(image) {
      const { urls: { full: url } } = image
      const file = uploadcare.fileFrom('url', url, this.settings)

      this.dialogApi.addFiles([file])
    },
  },
})
</script>

<template>
  <base-loader
    v-if="loading"
  />
  <div
    v-else
    :class="$style.container"
  >
    <template v-for="(image, index) of images">
      <div
        :key="`unsplash-img-${ index }`"
        :class="$style.imageWrapper"
        @click="chooseImage(image)"
      >
        <img
          :class="$style.image"
          :src="image.urls.thumb"
          :alt="image.description"
        >
      </div>
    </template>
    <div :class="$style.buttonWrapper">
      <button
        :class="[
          'el-button el-button--default',
          loadingMore && 'is-disabled',
          $style.button
        ]"
        :disabled="loadingMore"
        @click="fetchImages"
      >
        <span>
          Load more images
        </span>
      </button>
    </div>
    <svg
      width="0"
      height="0"
      style="position:absolute"
    >
      <symbol
        id="uploadcare--icon-unsplash"
        viewBox="0 0 32 32"
      >
        <path d="M 16 22.928 L 23.416 27.4 L 21.454 18.965 L 28 13.292 L 19.37 12.552 L 16 4.6 L 12.629 12.552 L 4 13.292 L 10.546 18.965 L 8.584 27.4 Z" />
      </symbol>
    </svg>
  </div>
</template>

<style lang="scss" module>
:global .uploadcare--tab_name_unsplash {
  position: relative;
}

.container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: rem(14px);
  width: 100%;
  padding: rem(0 14px);
  margin-top: rem(58px);
  overflow: scroll;
}

.imageWrapper {
  position: relative;
  flex-grow: 1;
  margin-bottom: rem(14px);
  cursor: pointer;
}

.image {
  width: 100%;
  height: rem(170px);
  object-fit: cover;
}

.buttonWrapper {
  display: flex;
  grid-column: 2 / -2;
  align-items: center;
  margin-bottom: rem(14px);
}

.button {
  width: 100%;
}
</style>
